const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M16 3.5c3.1 4.1 3.1 8.4 0 12.5-3.1-4.1-3.1-8.4 0-12.5Z" fill="#43B0CE" />
    <path d="M28.5 16c-4.1 3.1-8.4 3.1-12.5 0 4.1-3.1 8.4-3.1 12.5 0Z" fill="#2E96B0" />
    <path d="M16 28.5c-3.1-4.1-3.1-8.4 0-12.5 3.1 4.1 3.1 8.4 0 12.5Z" fill="#7FD0E6" />
    <path d="M3.5 16c4.1-3.1 8.4-3.1 12.5 0-4.1 3.1-8.4 3.1-12.5 0Z" fill="#43B0CE" />
  </svg>
);

export default LogoMark;
